import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      /**
       * Tailwind Merge will consider everything with the same prefix as conflicting.
       * To make sure that doesn't happen, we need to add the font-size classes here.
       *
       */
      'font-size': ['text-body-md', 'text-body-lg', 'text-ui-xs', 'text-ui-sm', 'text-ui-md', 'text-ui-lg', 'text-heading-4xs', 'text-heading-3xs', 'text-heading-2xs', 'text-heading-xs', 'text-heading-sm', 'text-heading-md', 'text-heading-lg', 'text-heading-xl', 'text-heading-2xl', 'text-heading-3xl', 'text-heading-display-xxs', 'text-heading-display-xs', 'text-heading-display-sm', 'text-heading-display-md', 'text-heading-display-lg', 'text-heading-display-xl', 'text-icon-sm', 'text-icon-md', 'text-icon-lg', 'text-badge-xs', 'text-badge-sm', 'text-badge-md', 'text-badge-lg', 'text-badge-xl', 'text-button-xs', 'text-button-sm', 'text-button-md', 'text-button-lg', 'text-quote-md', 'text-quote-lg', 'text-avatar-lg', 'text-avatar-xl', 'text-avatar-2xl', 'text-avatar-3xl']
    }
  }
})
/**
 * Merges multiple class values into a single class value.
 *
 * @param inputs - The class values to merge.
 * @returns The merged class value.
 *
 * @example
 * classMerge('text-primary', 'text-secondary')
 * //=> 'text-primary text-secondary'
 *
 * @example with conditional classes
 * classMerge('text-primary', { 'text-secondary': true })
 * //=> 'text-primary text-secondary'
 */
export function classMerge (...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
